import { render } from "./ImageView.vue?vue&type=template&id=82942274&scoped=true"
import script from "./ImageView.vue?vue&type=script&lang=ts"
export * from "./ImageView.vue?vue&type=script&lang=ts"

import "./ImageView.vue?vue&type=style&index=0&id=82942274&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-82942274"

export default script